class SubscriptionForm extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector('form[action^="/cart/add"]');
    this.productFormWrapper = this.closest(".product-form");
    this.frequencyToggle = this.querySelector('button[is="toggle-button"]');
    this.frequencySelector = this.querySelector('select[name="frequency"]');
    this.frequencySelector && this.frequencySelector.addEventListener("change", this.onFrequencyChange.bind(this));
    this.addToCartButton = this.querySelector("button#AddToCart");
    this.addToCartButton && this.addToCartButton.addEventListener("click", this.onSubmit.bind(this));
  }

  onFrequencyChange(e) {
    this.frequencyToggle && (this.frequencyToggle.querySelector("span.select__selected-value").innerText = this.frequencySelector.value);
  }

  getCart(callback) {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => { callback(cart); })
      .catch((err) => { console.log(err); });
  }

  updateCart(cart) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        cart: cart,
        openMiniCart: true
      }
    }));
    const quickBuyDrawer = this.closest("quick-buy-drawer");
    quickBuyDrawer && (quickBuyDrawer.open = false);
  }

  onSubmit(e) {
    e.preventDefault();
    const id = this.productForm.querySelector('input[name="id"]').value;
    const quantityInput = this.productFormWrapper.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? quantityInput.value : 1;
    const frequency = this.frequencySelector ? this.frequencySelector.value : this.querySelector('input[name="frequency"]').value;

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: quantity,
        properties: {
          "Frequência da assinatura": frequency,
          _frequency: frequency
        }
      }]
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body
    })
      .then(() => {
        this.getCart((cart) => {
          this.updateCart(cart);
          /*Abrir drawer*/
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: t,
              openMiniCart: true
            }
          }));
          // this.dispatchEvent(new CustomEvent("cart-notification:show", {
          //   bubbles: true,
          //   cancelable: true,
          //   detail: {
          //     status: "success",
          //     error: ""
          //   }
          // }));
        });
      })
      .catch((err) => { console.log(err); });
  }
}
customElements.define("subscription-form", SubscriptionForm);


class PurchaseTypeOptions extends SubscriptionForm {
  constructor() {
    super();
    this.productJson = JSON.parse(this.getAttribute("data-product-json"));
    this.productFormWrapper = this.closest(".product-form");
    this.purchaseTypeRadios = this.querySelectorAll('input[name="purchase-type"]');
    this.purchaseTypeRadios.forEach((el) => {
      el.addEventListener("change", this.onPurchaseTypeChange.bind(this));
      el.addEventListener("change", this.onRemoveHelpText.bind(this));
    });
    this.purchaseType = this.querySelector('input[name="purchase-type"]:checked').value;
    this.frequencySelector = this.querySelector('select[name="frequency"]');
    this.frequencySelector && this.frequencySelector.addEventListener("change", this.onFrequencyChange.bind(this));
    this.toggleHelpTextBtn = this.querySelector(".toggle-help-text");
    this.toggleHelpTextBtn && this.toggleHelpTextBtn.addEventListener("click", this.onToggleHelpText.bind(this));
    this.frequencyWrapper = this.querySelector(".frequency-wrapper");
    this.productForm = this.closest('form[action^="/cart/add"]');
    this.productForm.addEventListener("change", this.updatePrices.bind(this));
    this.addToCartButton = this.productForm.querySelector("button#AddToCart");
    this.addToCartButton && this.addToCartButton.addEventListener("click", this.onSubmit.bind(this));
    this.init();
  }

  init() {
    const select = this.productFormWrapper.querySelector(".product-form__option-selector[data-option-name='recorrência'] select");
    if (select) {
      select.value === select.querySelector("option").value
        ? this.querySelector("label[for='one_time_purchase']").click()
        : this.querySelector("label[for='subscription_purchase']").click();
    }
    this.updatePrices();
  }

  formatMoney(value) {
    return `R$ ${(value / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }

  updatePrices() {
    const selectedOptions = [];
    this.productFormWrapper.querySelectorAll(".product-form__option-selector:not(.product-form__option-selector--property-selector) option:checked")
      .forEach((el) => { selectedOptions.push(el.value); });
    selectedOptions.pop();

    let lowestPrice = 0;
    let highestPrice = 0;

    this.productJson.variants.forEach((variant) => {
      if (variant.title.includes(selectedOptions.join(" / "))) {
        if (lowestPrice === 0 || variant.price < lowestPrice) lowestPrice = variant.price;
        if (variant.price > highestPrice) highestPrice = variant.price;
      }
    });

    this.querySelector("#one_time_purchase__price").innerHTML = this.formatMoney(highestPrice);
    this.querySelector("#subscription_purchase__price").innerHTML = this.formatMoney(lowestPrice);
  }

  onFrequencyChange(e) {
    super.onFrequencyChange(e);
    const value = e.target.value;
    const button = this.productFormWrapper.querySelector(`.product-form__option-selector[data-option-name='recorrência'] button[value='${value}']`);
    button && button.click();
  }

  onToggleHelpText(e) {
    e.preventDefault();
    this.classList.toggle("show-help-text");
  }

  onRemoveHelpText(e) {
    if (e.target.value === "one-time") {
      this.classList.remove("show-help-text");
    }
  }

  onPurchaseTypeChange(e) {
    this.purchaseType = e.target.value;

    if (this.purchaseType === "subscription") {
      this.addToCartButton.innerText = this.addToCartButton.getAttribute("data-subscription-text");
      this.classList.add("show-frequency");
      const value = this.frequencySelector.value;
      const button = this.productFormWrapper.querySelector(`.product-form__option-selector[data-option-name='recorrência'] button[value='${value}']`);
      button && button.click();
    } else {
      this.addToCartButton.innerText = this.addToCartButton.getAttribute("data-one-time-text");
      this.classList.remove("show-frequency");
      const select = this.productFormWrapper.querySelector(".product-form__option-selector[data-option-name='recorrência'] select");
      if (select) {
        const value = select.querySelector("option").value;
        const button = this.productFormWrapper.querySelector(`.product-form__option-selector[data-option-name='recorrência'] button[value='${value}']`);
        button && button.click();
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const id = this.productForm.querySelector('input[name="id"]').value;
    const quantityInput = this.productFormWrapper.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? quantityInput.value : 1;
    const frequency = this.frequencySelector ? this.frequencySelector.value : this.querySelector('input[name="frequency"]').value;

    const properties = this.purchaseType === "subscription"
      ? { "Frequência da assinatura": frequency, _frequency: frequency }
      : {};

    this.productFormWrapper.querySelectorAll("select.property-selector").forEach((el) => {
      properties[el.name] = el.value;
    });

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: quantity,
        properties: properties
      }]
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body
    })
      .then(() => {
        this.getCart((cart) => {
          this.updateCart(cart);
          /*Abrir drawer*/
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: t,
              openMiniCart: true
            }
          }));
        });
      })
      .catch((err) => { console.log(err); });
  }
}
customElements.define("purchase-type-options", PurchaseTypeOptions);
